export default __webpack_public_path__ + "static/media/carto-black.f417334b.PNG";